import cx from 'classix';

/** Handles Contentful page blockquotes in WYSIWYQ entries. See apps/web/src/app/contentful/contentful-styles.css
 * for extra styles that create large yellow quote (") marks around the content. */
const Quote = ({ text, quotee, isSmall }: { text: string; quotee?: string; isSmall?: boolean }) => {
  return (
    <>
      <blockquote
        className={cx(
          'text-gray-700 italic',
          !isSmall && 'text-2xl sm:text-3xl leading-7 sm:leading-10',
          isSmall && 'text-md leading-6',
        )}
      >
        <p className='italic'>{text}</p>
      </blockquote>
      {quotee && (
        <div
          className={cx(
            'font-header text-gray-500 text-right',
            'text-xl sm:text-2xl leading-6 sm:leading-7',
          )}
        >
          - {quotee}
        </div>
      )}
    </>
  );
};

export default Quote;
